import React, { useEffect, useState } from "react";
import style from "./Reports.module.css";
import MenuBar from "./MenuBar";
import DateRangePicker from "./DateRangePicker";
import { toast } from "react-toastify";
import moment from "moment";
import { FaSpinner } from "react-icons/fa";
import { API_BASE_URL } from "./config.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import pdfIcon from "./assets/SOA.png";
import History from "./assets/History.png";
import PurReg from "./assets/PurReg.png";
import Summary from "./assets/Summary.png";
import GRNvsREJ from "./assets/GRNvsREJ.png";
import HeadingBar from "./HeadingBar.js";
const Reports = () => {
  const isEmbedded = sessionStorage.getItem("mode") === "embedded";
  const vendorDataRaw = sessionStorage.getItem("vendordata");
  const vendorInfo = vendorDataRaw ? JSON.parse(vendorDataRaw) : null;
  const vendorCode = vendorInfo?.CardCode || "";
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [selectedValue, setSelectedValue] = useState("SOA"); // default SOA
  const [loading, setLoading] = useState(false); // ✅ loading state

  useEffect(() => {
    const start = moment().startOf("quarter").format("YYYY-MM-DD");
    const end = moment().endOf("quarter").format("YYYY-MM-DD");
    setFromDate(start);
    setToDate(end);
  }, [vendorCode]);

  const handleDateChange = (start, end) => {
    setFromDate(start);
    setToDate(end);
  };

  const jsonToCSV = (jsonData) => {
    if (!jsonData || jsonData.length === 0) return "";
    const headers = Object.keys(jsonData[0]);
    const csvRows = [];
    csvRows.push(headers.join(","));
    jsonData.forEach((row) => {
      const values = headers.map((header) => {
        let val = row[header] ?? "";
        val = val.toString().replace(/"/g, '""');
        if (val.search(/("|,|\n)/g) >= 0) {
          val = `"${val}"`;
        }
        return val;
      });
      csvRows.push(values.join(","));
    });
    return csvRows.join("\n");
  };

  const handleDownloadSummary = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}/SAPReport/DownloadCSVSummary?VendorCode=${vendorCode}&FromDate=${fromDate}&ToDate=${toDate}`,
      );
      if (response.status === 204) {
        toast.warn("No record found");
        return;
      }

      if (!response.ok) throw new Error("Failed to fetch data");

      const jsonData = await response.json();
      const csv = jsonToCSV(jsonData);

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Summary_${vendorCode}_${fromDate}_to_${toDate}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success("Report donwloaded successfully.");
    } catch (error) {
      console.error("CSV Download error:", error);
      toast.error("Could not download CSV.");
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadGRNvREJ = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}/SAPReport/DownloadCSVGRNvsRej?VendorCode=${vendorCode}&FromDate=${fromDate}&ToDate=${toDate}`,
      );
      if (response.status === 204) {
        toast.warn("No record found");
        return;
      }
      if (!response.ok) throw new Error("Failed to fetch data");

      const jsonData = await response.json();
      const csv = jsonToCSV(jsonData);

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `GRNvsREJ_${vendorCode}_${fromDate}_to_${toDate}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success("Report donwloaded successfully.");
    } catch (error) {
      console.error("CSV Download error:", error);
      toast.error("Could not download CSV.");
    } finally {
      setLoading(false);
    }
  };
  // 📌 Download CSV
  const handleDownloadCSV = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}/SAPReport/DownloadCSV?VendorCode=${vendorCode}&FromDate=${fromDate}&ToDate=${toDate}`,
      );
      if (response.status === 204) {
        toast.warn("No record found");
        return;
      }
      if (!response.ok) throw new Error("Failed to fetch data");

      const jsonData = await response.json();
      const csv = jsonToCSV(jsonData);

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `PurchaseRegister_${vendorCode}_${fromDate}_to_${toDate}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success("Report donwloaded successfully.");
    } catch (error) {
      console.error("CSV Download error:", error);
      toast.error("Could not download CSV.");
    } finally {
      setLoading(false);
    }
  };

  // 📌 Download PDF (SOA)
  const handleDownloadSOA = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}/SAPReport/DownloadSOA?VendorCode=${vendorCode}&FromDate=${fromDate}&ToDate=${toDate}`,
      );
      if (!response.ok) throw new Error("Failed to download PDF");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `SOA_${vendorCode}_${fromDate}_to_${toDate}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
      toast.success("Report donwloaded successfully.");
    } catch (error) {
      console.error("PDF Download error:", error);
      toast.error("Could not download PDF.");
    } finally {
      setLoading(false);
    }
  };

  // 📌 Master download handler
  const handleDownload = () => {
    if (selectedValue === "SOA") {
      handleDownloadSOA();
    } else if (selectedValue === "PUR") {
      handleDownloadCSV();
    }
  };

  return (
    <div className={style.PurchaseOrderDetails}>
      {!isEmbedded && (
        <div className={style.HeadingBarContainer}>
          <HeadingBar />
        </div>
      )}
      <div className={style.PurchaseOrderDetailsContainer}>
        <div className={style.MenuBarContainer}>
          <MenuBar />
        </div>
        <div className={style.MainPurchaseOrderDetailsContainer}>
          <div className={style.MenuNameDetails}>Reports</div>
          <div className={style.filterArea}>
            <div className={style.pofilter}>
              {/* <div>Report Name</div>
              <select
                value={selectedValue}
                onChange={(e) => setSelectedValue(e.target.value)}
              >
                <option value="SOA">SOA</option>
                <option value="PUR">Purchase Register</option>
              </select> */}
            </div>
            <div className={style.datearea}>
              <DateRangePicker
                className={style.daterangepicker}
                onDateChange={handleDateChange}
                startDate={fromDate}
                endDate={toDate}
              />

              {/* <button onClick={handleDownload} disabled={loading}>
                Download
              </button> */}
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-md-3 col-sm-6 mb-3">
              <div className={style.reportTile} onClick={handleDownloadSOA}>
                <img src={pdfIcon} alt="PDF" />
                <span>SOA (PDF)</span>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 mb-3">
              <div className={style.reportTile} onClick={handleDownloadCSV}>
                <img src={PurReg} alt="CSV" />
                <span>Purchase (CSV)</span>
              </div>
            </div>

            <div className="col-md-3 col-sm-6 mb-3">
              <div className={style.reportTile} onClick={handleDownloadGRNvREJ}>
                <img src={GRNvsREJ} alt="Summary" />
                <span>GRN vs Rejecetd (CSV)</span>
              </div>
            </div>

            <div className="col-md-3 col-sm-6 mb-3">
              <div className={style.reportTile} onClick={handleDownloadSummary}>
                <img src={Summary} alt="Summary" />
                <span>Summary (CSV)</span>
              </div>
            </div>
            {/* <div className="col-md-3 col-sm-6 mb-3">
              <div className={style.reportTile} onClick={handleDownloadSummary}>
                <img src={History} alt="History" />
                <span>History</span>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {loading && (
        <div className={style.loaderOverlay}>
          <div className={style.loader}></div>
        </div>
      )}
    </div>
  );
};

export default Reports;
